import { render, staticRenderFns } from "./EventReservation.vue?vue&type=template&id=5bd0e25e&scoped=true"
import script from "./EventReservation.vue?vue&type=script&lang=js"
export * from "./EventReservation.vue?vue&type=script&lang=js"
import style0 from "./EventReservation.vue?vue&type=style&index=0&id=5bd0e25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0e25e",
  null
  
)

export default component.exports